/* eslint-disable react-hooks/rules-of-hooks */
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ErrorWithCode } from 'apps/web/components/organisms/ErrorModalDetails';
import { PROMPT_PER_DESIGN } from 'apps/web/constants/imageGeneration';
import { PhotoDesign } from 'apps/web/enums/photoDesign';

export interface GenerateImageParams {
  topic: string;
  design: PhotoDesign;
}

export const generateImage = (
  onSuccess?: (data: { image: string }) => void,
  onError?: (error: ErrorWithCode) => void
): UseMutationResult<unknown, unknown, GenerateImageParams> => {
  return useMutation({
    mutationFn: async ({ topic, design }: GenerateImageParams) => {
      const promptName = PROMPT_PER_DESIGN[design];
      const response = await fetch(`/api/ai-image?promptName=${promptName}&topic=${topic}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return await response.json();
    },
    onSuccess,
    onError,
  });
};
